import { UIText1, UIHeading2, Responsive, Button } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IAnnouncementForBuilderProps {
  onClose(): void;
}

export const RejectionForBuilder = ({ onClose }: IAnnouncementForBuilderProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['image']} />
      <div className={styles['description']}>
        <UIHeading2 textAlign="center">
          Застройщик и агент могут только отвечать&nbsp;на&nbsp;вопросы и&nbsp;отзывы
        </UIHeading2>
        <UIText1 textAlign="center">Посмотрите, есть ли по вашим ЖК открытые вопросы&nbsp;и&nbsp;отзывы</UIText1>
      </div>
      <div className={styles['action']}>
        <Responsive phone>
          <Button size="M" onClick={onClose}>
            Закрыть
          </Button>
        </Responsive>
      </div>
    </div>
  );
};
